<template>
  <layout-content>
    <template #header>
      {{ $t('db.breadcrumb.database.import') }}
    </template>

    <recipient-table v-bind="recipents_props" />
  </layout-content>
</template>

<script>
  import { DataBaseService } from '@db/services/DataBaseService';
  import { mapActions } from 'vuex';
  import RecipientTable from '@db/components/recipients/recipients-import-table';

  export default {
    props: {
      upload_list: {
        type: [Array, Object]
      }
    },

    components: {
      RecipientTable
    },

    computed: {
      recipents_props() {
        const { database_id, file_id } = this.$route.params;
        return { database_id, file_id };
      }
    },

    mounted() {
      DataBaseService.getItem(this.$route.params.database_id)
        .then(res => {
          this.add_breadcrumbs({
            items: [
              {
                title: res['name'],
                route: { name: 'db.database.edit', params: { id: this.$route.params.database_id } }
              },
              {
                route: '#',
                title: 'db.breadcrumb.database.import'
              }
            ]
          });
        })
        .finally(() => this.endLoadingPage());
    },

    methods: {
      ...mapActions('shared/breadcrumbs', { add_breadcrumbs: 'add_items' })
    }
  };
</script>
